import React from "react";
import styled from "styled-components";
import { socials } from "../../config";
import { renderLogoIcon } from "../../utils/utils";

const StyledContactSection = styled.section`
  position: relative;
  background: var(--background);
  color: var(--black-dark);
`;

const StyledContactBody = styled.div`
  grid-template-columns: 100%;

  @media (min-width: 1024px) {
    grid-template-columns: 50% 50% !important;
  }
`;

const StyledContactContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;

  h2,
  h3 {
    margin-bottom: var(--mb-3);
  }

  p {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    margin-bottom: var(--mb-2);
    line-height: 24px;
  }

  @media (min-width: 1024px) {
    text-align: initial;

    p {
      max-width: 70%;
    }
  }
`;

const StyledContactMeContainer = styled.div`
  margin-top: var(--mb-4);
  margin-bottom: var(--mb-4);
`;

const StyledSocialContactList = styled.ul`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (min-width: 1024px) {
    justify-content: flex-start;
  }
`;

const StyledSocialContactListItem = styled.li`
  margin: 0px var(--mb-1);
  float: left;
  position: relative;

  &:hover a {
    fill: var(--gray-dark);
  }

  @media (min-width: 768px) {
    margin: 0;
    margin-right: var(--mb-4);
  }
`;

const StyledSocialLink = styled.a`
  font-size: var(--big-font-size);
  cursor: pointer;
  fill: var(--gray-regular);

  .social-contact-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }

  @media (min-width: 768px) {
    .social-contact-icon {
      width: 30px;
      height: 30px;
    }
  }
`;

const StyledContactAdditional = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: var(--mb-2);

  .gif {
    width: 90%;
    height: 100%;
    margin-bottom: var(--mb-2);
  }

  .meme-explain {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    font-weight: var(--font-bold);
  }

  @media (min-width: 1024px) {
    .gif {
      width: 60%;
    }
  }
`;

const Contact = () => {
  return (
    <StyledContactSection
      className="section"
      id="contact-section"
      data-sal="slide-up"
      data-sal-delay="600"
      data-sal-easing="ease"
      data-sal-duration="1500"
    >
      <span id="contact" className="anchor"></span>
      <StyledContactBody className="bd-grid">
        <StyledContactContent>
          <h2>Let's Talk</h2>
          <p>
            If you're looking to collaborate on awesome projects or looking for
            a freelancer , feel free to drop a line.
          </p>
          <StyledContactMeContainer>
            <a className="contained-btn" href="mailto:lowbak1998@hotmail.com">
              Say Hello
            </a>
          </StyledContactMeContainer>
          <div>
            <StyledSocialContactList className="contact-socials">
              {socials.map((item, i) => (
                <StyledSocialContactListItem key={`social-${i}`}>
                  <StyledSocialLink href={item.url} target="_blank">
                    {renderLogoIcon(item.name, "social-contact-icon")}
                  </StyledSocialLink>
                </StyledSocialContactListItem>
              ))}
            </StyledSocialContactList>
          </div>
        </StyledContactContent>
        <StyledContactAdditional>
          <img
            className="gif"
            src="https://www.hubspot.com/hubfs/Smiling%20Leo%20Perfect%20GIF.gif"
            alt="meme"
          />
          <p className="meme-explain">
            "Looking forward to our next collaboration"
          </p>
        </StyledContactAdditional>
      </StyledContactBody>
    </StyledContactSection>
  );
};

export default Contact;
